/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { useBlockProps } from '@wordpress/block-editor';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */

import { Fragment, useEffect  } from '@wordpress/element';
import { InspectorControls, BlockControls, AlignmentControl, PanelColorSettings } from '@wordpress/block-editor';
import { PanelBody, SelectControl } from '@wordpress/components';
import ServerSideRender from '@wordpress/server-side-render';

export default function Edit( props ) {
	const { setAttributes, attributes } = props;
	const { textAlign, tripTaxonomy, textColor, extraClass } = attributes;
	
	useEffect(() => {
        attributes.extraClass === '' 
        && setAttributes( { extraClass : props.clientId } )
    }, []);

	const textColorSettings = [
		{
			value: textColor,
			onChange: colorValue => setAttributes({ textColor: colorValue }),
			label: __( "Text Color", 'wp-travel-blocks' )
		}
	];

	return (
		<div { ...useBlockProps() }>
			<Fragment>
			<BlockControls>
				<AlignmentControl
					value={textAlign}
					onChange={(nextAlign) => {
						setAttributes({ textAlign: nextAlign });
					}}
				/>
			</BlockControls>
			<InspectorControls>
				<PanelBody title={ __( 'Trip Categories', 'wp-travel-blocks' ) } >
					<SelectControl
						value={tripTaxonomy}
						options={[
							{
								label: __( 'Activities', 'wp-travel-blocks' ),
								value: 'activity'
							}, {
								label: __( 'Destination', 'wp-travel-blocks' ),
								value: 'travel_locations'
							}, {
								label: __( 'Keywords', 'wp-travel-blocks' ),
								value: 'travel_keywords'
							}, {
								label: __( 'Trip Type', 'wp-travel-blocks' ),
								value: 'itinerary_types'
							}
						] }
						onChange={ ( value ) => {
							setAttributes( { tripTaxonomy: value } );
						} }
					/>
				</PanelBody>
				<PanelColorSettings
					title={__('Text Color', 'wp-travel-blocks')}
					colorSettings={textColorSettings}
					initialOpen={false}
				/>
			</InspectorControls>
			</Fragment>
			<ServerSideRender
				block="wp-travel-blocks/trip-categories"
				attributes={ props.attributes }
			/>
		</div>
	);
}
